$( document ).ready(function() {

    $('#navbarContent').on('hide.bs.collapse', function () {
        $('.hamburger').toggleClass('is-active');
    })
    $('#navbarContent').on('show.bs.collapse', function () {
        $('.hamburger').toggleClass('is-active');
    })

    $('#menuNavbar .nav-link').on('click', function () {
        $('#navbarContent').collapse('hide');
    })

});
